import { DUPLICATE_EVENT_INFO_ROUTE } from '@constants/routes';
import { Event, EventListItem } from '@domain/event';

export const createPathToDuplicate = ({ event, companyId }: { event: Event | EventListItem; companyId: string }) => {
  return event.settings.isPublished
    ? DUPLICATE_EVENT_INFO_ROUTE.replace(':companyId', companyId)
        .replace(':clubSlug', event.club.slug)
        .replace(':eventId', event.id)
    : undefined;
};
